import { defineComponent as _defineComponent } from 'vue'
import {
  computed, onMounted, ref, watch
} from 'vue';
import type { CSSProperties } from 'vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import { useWindowSize } from '@vueuse/core/index';
import useTokenState from '@/state/tokenState';
import MeetingHeader from '@/components/meeting-scheduler/components/MeetingHeader.vue';
import MeetingForm from '@/components/meeting-scheduler/components/MeetingForm.vue';
import MeetingPicker from '@/components/meeting-scheduler/components/MeetingPicker.vue';
import MeetingCalendar from '@/components/meeting-scheduler/components/MeetingCalendar.vue';
import MeetingSearch from '@/components/meeting-scheduler/components/MeetingSearch.vue';
import MeetingDetail from '@/components/meeting-scheduler/components/MeetingDetail.vue';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import { useConflictDismiss } from '@/components/meeting-scheduler/composables/useConflictPopover';
import MeetingFooter from '@/components/meeting-scheduler/components/MeetingFooter.vue';
import DialogConfirmAction from '@/components/meeting-scheduler/components/DialogConfirmAction.vue';

// Single "dismiss the conflict popover on the next click" listener for the whole scheduler —
// it hosts both the detail (VIEW) and form (DRAFT) views that render the conflict popover.

export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingScheduler',
  setup(__props) {

useConflictDismiss();
const { isMobileWidth } = useResponsiveness();
const { isOpen, mode, closeScheduler } = useMeetingScheduler();
const { isLoggedIn } = useTokenState();

const { width: windowWidth, height: windowHeight } = useWindowSize();

const popupYPos = ref<number>(0);
const popupXPos = ref<number>(0);
const initialWidthPx = 802;

const layerStyle = computed<CSSProperties>(() => (isMobileWidth.value
  ? {
    paddingBottom: '0',
    overflowY: 'auto'
  }
  : {
    paddingBottom: '0',
    minHeight: 'min(724px, 90vh)',
    maxHeight: '90vh',
    overflowY: 'auto'
  }));

watch(isLoggedIn, (loggedIn) => {
  if (!loggedIn) closeScheduler();
});

onMounted(() => {
  popupXPos.value = (windowWidth.value - initialWidthPx) / 2;
  popupYPos.value = windowHeight.value * 0.05; // TODO: Muss noch angepasst werden
});

return { __sfc: true,isMobileWidth, isOpen, mode, closeScheduler, isLoggedIn, windowWidth, windowHeight, popupYPos, popupXPos, initialWidthPx, layerStyle, BCXQuickLayer, MeetingHeader, MeetingForm, MeetingPicker, MeetingCalendar, MeetingSearch, MeetingDetail, MeetingFooter, DialogConfirmAction }
}

})